import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import Button from 'eventbrite_design_system/button/Button';
import Icon from 'eventbrite_design_system/icon/Icon';

export default class IconBanner extends PureComponent {
    static propTypes = {
        heading: EBPropTypes.translation,
        iconType: EBPropTypes.translation,
        CTA: EBPropTypes.translation,
        onCTAClick: PropTypes.func,
        dataAutomation: PropTypes.string,
    };

    render() {
        const {
            heading,
            iconType,
            CTA,
            onCTAClick,
            dataAutomation,
        } = this.props;
        let iconHeroContent = null;

        if (CTA) {
            iconHeroContent = (
                <div>
                    <p className="eds-l-pad-top-4 eds-l-pad-bot-6 eds-text-bl eds-text-color--grey-600">
                        {heading}
                    </p>
                    <Button
                        type="link"
                        onClick={onCTAClick}
                        data-automation={dataAutomation}
                    >
                        {CTA}
                    </Button>
                </div>
            );
        } else {
            iconHeroContent = (
                <p
                    className="eds-l-pad-top-4 eds-l-pad-bot-6 eds-text-bl eds-text-color--grey-600"
                    data-automation={dataAutomation}
                >
                    {heading}
                </p>
            );
        }

        return (
            <div className="eds-l-mar-vert-14 eds-l-pad-top-14 eds-text--center">
                <div className="eds-g-cell eds-g-cell-7-12">
                    <Icon type={iconType} size="medium" />
                    {iconHeroContent}
                </div>
            </div>
        );
    }
}
